module.exports = __webpack_public_path__ + "img/relacionescolor-induspac.0658d2fa.png";